import { useParams } from 'react-router';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import usePatchHook from '../../customHooks/usePatchHook';
import loadable from '@loadable/component';
import CreateIcon from '../../Icons/Create';

const EditDeliveryChargeTemplateComponent = loadable(
  () => import("../../components/DeliveryChargeTemplate/EditDeliveryChargeTemplate")
);

const EditDeliveryChargeTemplate = () => {
  const { id } = useParams()

  const { refetch } = useGetHook({
    queryKey: [`delivery-charge-template${id}`],
    url: `${APIS.DELIVERY_CHARGE_TEMPLATE}${id}/`,
    params: {},
  });



  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`delivery-charge-template-${id}`],
    navigateURL: "/delivery-charge-template",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY_CHARGE_TEMPLATE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">Edit Rate Template</span>
      </div>
      <EditDeliveryChargeTemplateComponent
        isLoading={isPatchLoading}
        handleEdit={handleEdit}
        refetch={refetch}
      />
    </>
  )
}

export default EditDeliveryChargeTemplate
